"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Day = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var Day = function Day(_ref) {
  var onClick = _ref.onClick,
      selected = _ref.selected,
      today = _ref.today,
      rangeStart = _ref.rangeStart,
      rangeMiddle = _ref.rangeMiddle,
      rangeEnd = _ref.rangeEnd,
      day = _ref.day,
      key = _ref.key,
      disabled = _ref.disabled;
  var isClickable = typeof onClick === 'function' && typeof day === 'number';
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('a-day', {
      'a-day--selected': selected,
      'a-day--today': today,
      'a-day--range-start': rangeStart,
      'a-day--range-middle': rangeMiddle,
      'a-day--range-end': rangeEnd,
      'a-day--disabled': disabled
    }),
    key: key,
    onClick: isClickable ? function () {
      return onClick(day);
    } : undefined
  }, day);
};

exports.Day = Day;